import React, { useState } from 'react';

import { PropertiesSection } from '../../subpanels/properties/PropertiesSection';
import { LaborFactors } from './LaborFactors';
import { LumberFactors } from './LumberFactors';
import { PlateFactors } from './PlateFactors';

type ChildKey = 'lumber' | 'plates' | 'labor';

interface Props {
  readonly disabled: boolean;
}

export function CostFactorsSection({ disabled }: Props) {
  const [expanded, setExpanded] = useState<Record<ChildKey, boolean>>({
    lumber: false,
    plates: false,
    labor: false,
  });

  const toggle = (key: ChildKey) => setExpanded((current) => ({ ...current, [key]: !current[key] }));

  return (
    <>
      <PropertiesSection
        title="Lumber"
        depth={1}
        expanded={expanded.lumber}
        onExpand={() => toggle('lumber')}
        onCollapse={() => toggle('lumber')}
      >
        <LumberFactors disabled={disabled} />
      </PropertiesSection>

      <PropertiesSection
        title="Plates"
        depth={1}
        expanded={expanded.plates}
        onExpand={() => toggle('plates')}
        onCollapse={() => toggle('plates')}
      >
        <PlateFactors disabled={disabled} />
      </PropertiesSection>

      <PropertiesSection
        title="Labor"
        depth={1}
        expanded={expanded.labor}
        onExpand={() => toggle('labor')}
        onCollapse={() => toggle('labor')}
      >
        <LaborFactors disabled={disabled} />
      </PropertiesSection>
    </>
  );
}
